<div class="register-layout">
  <div class="row form-layout">
    <div class="col-md-10 form position-relative">
      <div>
        <div class="row">
          <form [formGroup]="selectionForm">
            <br />
            <div class="form-label">
              <h2 class="dashboard-sub-heading">Customer Creation</h2>
            </div>

            <hr />
            <br />
            <br />
            <div class="col-md-6 text-start">
              <label for="type" class="form-label"
              >Customer Creation Through</label
              >
              <select
                class="form-select"
                aria-label="Default select example"
                formControlName="type"
                [(ngModel)]="selectedValue"
                (change)="selectChange()"
              >
                <option *ngIf="subscriptionPlanList.length==0" value="0">Customer Profile Creation</option>
                <option *ngIf="profileList.length==0" value="1">Subscription Package Creation</option>
              </select>
            </div>
            <div class="row mb-3">
              <div class="col-5">
                <div *ngIf="isProfileCreation" class="form-label mt-5">
                  <h1 class="dashboard-sub-heading d-flex align-items-center">
                    Customer Profile Creation
                  </h1>
                </div>
              </div>
              <div class="col-7">
                <div *ngIf="isProfileCreation" class="form-label mt-5">
                  <button
                    type="button"
                    class="btn btn-primary btn-md btn-floating custom-icon-button1"
                    (click)="handleProfileCreate()"
                  >
                  </button>
                </div>
              </div>
            </div>
          </form>
          <div>

            <table
              *ngIf="isProfileCreation"
              class="align-middle mb-0 bg-white table table-md"
              [ngClass]="loading ? 'blur-background' : ''"
            >
              <thead class="bg-light">
              <tr>
                <th>Profile Name</th>
                <th>Description</th>
                <th>Default</th>
                <th>Action</th>

                <!-- <th></th> -->
              </tr>
              </thead>
              <div *ngIf="loading && isProfileCreation" class="text-center position-absolute top-50 start-50 " style="z-index: 10000;">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <tbody *ngFor="let profile of profileList">
              <tr>
                <td>
                  <p class="fw-normal mb-1">{{ profile.profileName }}</p>
                </td>
                <td>
                  <p class="fw-normal mb-1">{{ profile.description }}</p>
                </td>
                <td>
                  <div class="form-check">
                    <input
                      (change)="defaultProfile(profile.profileId)"
                      mdbCheckbox
                      [disabled]="profile.isDefault == 'YES' ? true : false"
                      class="form-check-input"
                      type="checkbox"
                      [checked]="profile.isDefault == 'YES' ? true : false"
                      value="1"
                      id="flexCheckDefault"
                    />
                  </div>
                </td>

                <!-- <td>
                  <button
                    type="button"
                    class="btn btn-link btn-sm btn-rounded"
                    (click)="exchangeEdit(1)"
                  >
                    Edit
                  </button>
                </td> -->
                <td>
                  <button
                    (click)="handleAccountDetailsView(profile.profileNumber)"
                    class="btn-sm btn-warning custom-icon-button2"
                  ></button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="isSubscribPack" class="row mb-3">
            <div class="col-6">
              <div class="form-label mt-5">
                <h1 class="dashboard-sub-heading d-flex align-items-center">
                  Subscription Package Creation
                </h1>
              </div>
            </div>
            <div class="col-6">
              <div class="form-label mt-5">
                <button
                  type="button"
                  class="btn btn-primary btn-md btn-floating custom-icon-button1"
                  (click)="handleSubscribePack()"
                ></button>
              </div>
            </div>

          </div>
          <div>

            <table
              *ngIf="isSubscribPack"
              class="table align-middle mb-0 bg-white table-lg"
              [ngClass]="loading ? 'blur-background' : ''"
            >
              <thead class="bg-light">
              <tr>
                <th>Package Name</th>
                <th>Description</th>
                <th>Default</th>
                <th>Action</th>
                <!-- <th></th>  -->
              </tr>
              </thead>
              <div *ngIf="loading && isSubscribPack" class="text-center position-absolute top-50 start-50 " style="z-index: 10000;">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <tbody *ngFor="let package of subscriptionPlanList">
              <tr>
                <td>
                  <p class="fw-normal mb-1">{{ package.packageName }}</p>
                </td>
                <td>
                  <p class="fw-normal mb-1">{{ package.packageDescription }}</p>
                </td>
                <td>
                  <div class="form-check">
                    <input
                      (change)="defaultSubscribePack(package.packageId)"
                      mdbCheckbox
                      [disabled]="package.isDefault == 'YES' ? true : false"
                      class="form-check-input"
                      type="checkbox"
                      [checked]="package.isDefault == 'YES' ? true : false"
                      value="1"
                      id="flexCheckDefault"
                    />
                  </div>
                </td>

                <td>
                  <button
                    type="button"
                    class="btn btn-link btn-sm btn-rounded"
                    (click)="subscribePackEdit(package.packageId)"
                  >
                    Edit
                  </button>
                </td>

                <!-- <td>
                  <button
                    type="button"
                    class="btn btn-link btn-sm btn-rounded"

                  >
                    Remove
                  </button>
                </td>  -->
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

